module.exports = vendor_0b2fa48833288709b867;


//////////////////
// WEBPACK FOOTER
// external "vendor_0b2fa48833288709b867"
// module id = 8
// module chunks = 53